import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { TrainingOverviewPageModule } from '../pages/training-overview/training-overview.module';
import { ApiProvider } from '../providers/api/api';
import { LineUpPageModule } from '../pages/line-up/line-up.module';
import { LineUpEditorPageModule } from '../pages/line-up-editor/line-up-editor.module';
import { TrainingResultEditorPageModule } from '../pages/training-result-editor/training-result-editor.module';


@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    TrainingOverviewPageModule,
    LineUpPageModule,
    LineUpEditorPageModule,
    TrainingResultEditorPageModule,
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    HttpModule,
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts